export const serviceItems = [
  {
    id: 's1',
    type: 'service',
    title: '家电深度清洗上门服务',
    summary: '专业工程师上门，空调、洗衣机、油烟机深度拆洗除菌，清洗前后对比可见，让家电焕然一新。',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20technician%20cleaning%20a%20wall%20mounted%20air%20conditioner%20in%20a%20bright%20tidy%20home%2C%20editorial%20service%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=svc-01&orientation=landscape',
    category: 'life',
    subCategory: '家政',
    serviceType: '家政清洁',
    price: '¥99 起 / 台',
    area: '市区全境',
    author: '91生活服务',
    source: '平台自营',
    publishTime: '2026-10-08 10:00',
    views: 42300,
    tags: ['家电清洗', '除菌', '上门服务'],
    content: [
      '长期使用的空调、洗衣机与油烟机内部容易堆积灰尘与油污，不仅影响使用效果，还可能滋生细菌。本服务由经过培训的专业工程师上门，对家电进行深度拆洗与除菌处理。',
      '服务流程：预约下单 → 工程师电话确认 → 上门拆洗 → 清洁消毒 → 现场试机验收。整个过程约 60-90 分钟，清洗前后可现场对比查看。',
      '服务保障：工程师自带专业工具与清洁剂，作业过程铺设防护垫，避免弄脏地面与墙面；清洗完成后会清理现场，还原整洁环境。',
      '温馨提示：预约时请说明家电品牌与型号，以便工程师准备合适的工具。本次提交为演示流程，实际服务请联系客服确认。',
    ],
  },
  {
    id: 's2',
    type: 'service',
    title: '全屋深度保洁套餐',
    summary: '针对搬家入住、季度大扫除场景，覆盖厨房、卫浴、门窗、地面等区域，一次彻底清洁到位。',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20bright%20living%20room%20with%20spotless%20floor%20and%20tidy%20furniture%2C%20professional%20home%20cleaning%20service%20photography%2C%20soft%20neutral%20background%2C%20natural%20light%2C%20high%20detail&width=800&height=600&seq=svc-02&orientation=landscape',
    category: 'life',
    subCategory: '家政',
    serviceType: '全屋保洁',
    price: '¥399 起 / 次',
    area: '市区及近郊',
    author: '91生活服务',
    source: '平台自营',
    publishTime: '2026-10-07 09:30',
    views: 31800,
    tags: ['全屋保洁', '大扫除', '搬家入住'],
    content: [
      '全屋深度保洁适合搬家入住、季度大扫除等场景，服务团队按照标准作业流程，对家中各区域进行系统清洁，让居住环境焕然一新。',
      '清洁范围包括：厨房油污与台面、卫浴洁具与水垢、门窗玻璃与轨道、地面与踢脚线，以及家具表面除尘等。可根据房型与需求灵活调整重点区域。',
      '服务保障：团队统一着装、自带环保清洁用品，作业前与业主确认清洁范围，作业中注意保护家具与电器，结束后邀请业主验收。',
      '温馨提示：本页面提交为演示，实际预约请通过客服热线或在线客服完成，工作人员会根据房屋面积与污渍程度给出准确报价。',
    ],
  },
  {
    id: 's3',
    type: 'service',
    title: '手机维修极速上门',
    summary: '屏幕更换、电池更换、进水处理等常见故障，市区下单最快 1 小时上门，原厂品质配件。',
    image:
      'https://readdy.ai/api/search-image?query=Technician%20repairing%20a%20smartphone%20with%20precision%20tools%20under%20bright%20task%20light%2C%20editorial%20repair%20service%20photography%2C%20clean%20neutral%20background%2C%20soft%20light%2C%20high%20detail&width=800&height=600&seq=svc-03&orientation=landscape',
    category: 'life',
    subCategory: '维修',
    serviceType: '数码维修',
    price: '¥129 起 / 次',
    area: '市区核心区',
    author: '91生活服务',
    source: '认证服务商',
    publishTime: '2026-10-06 15:40',
    views: 38700,
    tags: ['手机维修', '上门', '换屏'],
    content: [
      '手机出现碎屏、续航下降、进水等故障时，往往影响日常工作与生活。本服务提供上门维修，市区下单后最快 1 小时响应，快速解决常见故障。',
      '可处理项目：屏幕更换、电池更换、后盖更换、进水烘干与清洁、接口与扬声器检修等。配件均为正规渠道采购，部分机型支持原厂品质配件。',
      '服务流程：在线描述故障 → 工程师报价 → 确认后上门 → 现场维修 → 功能检测 → 满意付款。维修过程可全程旁观，透明放心。',
      '温馨提示：上门维修前请提前备份重要数据。本页面为服务演示，实际维修价格会因机型与故障程度有所差异。',
    ],
  },
  {
    id: 's4',
    type: 'service',
    title: '同城搬家拉货配送',
    summary: '小型搬家、家电配送、商场取货一站解决，多种车型可选，明码标价无隐形费用。',
    image:
      'https://readdy.ai/api/search-image?query=Moving%20truck%20with%20helper%20carrying%20cardboard%20boxes%20on%20a%20sunny%20residential%20street%2C%20editorial%20moving%20service%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light&width=800&height=600&seq=svc-04&orientation=landscape',
    category: 'life',
    subCategory: '搬家',
    serviceType: '同城货运',
    price: '¥68 起 / 单',
    area: '同城范围',
    author: '91生活服务',
    source: '认证服务商',
    publishTime: '2026-10-05 11:20',
    views: 27500,
    tags: ['搬家', '拉货', '同城配送'],
    content: [
      '无论是小型搬家、家电配送还是商场取货，同城搬运需求总是不期而至。本服务提供多种车型选择，随叫随到，帮你轻松解决搬运难题。',
      '车型选择：小型面包车适合少量物品与家电配送；中型货车适合小户型搬迁；大型货车适合大件家具与批量货物。可按需选择，费用透明。',
      '服务流程：填写起点终点与物品信息 → 系统预估费用 → 司机接单确认 → 上门装货 → 安全送达。装卸过程司机可协助搬运，费用另议。',
      '温馨提示：贵重易碎物品请提前说明并妥善包装。本页面提交为演示，实际用车请通过客服或平台下单确认。',
    ],
  },
  {
    id: 's5',
    type: 'service',
    title: '宠物上门喂养与遛狗',
    summary: '出差旅行不在家？认证宠物管家上门喂食、换水、铲屎、陪玩遛狗，全程拍照汇报。',
    image:
      'https://readdy.ai/api/search-image?query=Friendly%20person%20walking%20a%20happy%20dog%20in%20a%20sunny%20green%20park%2C%20warm%20editorial%20pet%20service%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=svc-05&orientation=landscape',
    category: 'life',
    subCategory: '生活',
    serviceType: '宠物照护',
    price: '¥39 起 / 次',
    area: '市区全境',
    author: '91生活服务',
    source: '认证宠物管家',
    publishTime: '2026-10-04 16:10',
    views: 46200,
    tags: ['宠物', '上门喂养', '遛狗'],
    content: [
      '出差、加班或旅行时，家里的毛孩子总是让人放心不下。本服务提供专业宠物管家上门照护，让主人出门在外也能安心。',
      '服务内容：喂食换水、清理猫砂或排泄物、陪伴互动、遛狗散步、简单清洁等。每次服务会拍照或录制视频，并同步反馈宠物状态。',
      '服务保障：宠物管家均经过实名认证与背景审核，熟悉常见宠物习性；上门前后与主人保持沟通，重要事项提前确认，确保照护到位。',
      '温馨提示：首次服务建议提前与管家沟通宠物性格与饮食禁忌。本页面提交为演示流程，实际预约请通过客服确认时间。',
    ],
  },
  {
    id: 's6',
    type: 'service',
    title: '老人陪诊与健康陪护',
    summary: '专业陪诊员全程陪同挂号、缴费、检查、取药，耐心细致，帮助老人安心就医。',
    image:
      'https://readdy.ai/api/search-image?query=Caring%20young%20assistant%20helping%20an%20elderly%20person%20walk%20in%20a%20bright%20hospital%20corridor%2C%20warm%20editorial%20care%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light&width=800&height=600&seq=svc-06&orientation=landscape',
    category: 'life',
    subCategory: '医疗',
    serviceType: '陪诊陪护',
    price: '¥198 起 / 半天',
    area: '市区主要医院',
    author: '91生活服务',
    source: '认证陪诊员',
    publishTime: '2026-10-03 08:15',
    views: 35100,
    tags: ['陪诊', '老人陪护', '就医'],
    content: [
      '子女不在身边或对医院流程不熟悉的老人，独自就医往往面临诸多不便。本服务提供专业陪诊员全程陪同，帮助老人顺利完成就医流程。',
      '服务内容：提前协助挂号、陪同候诊、协助缴费与检查、领取报告与药品、就医记录整理反馈。陪诊员耐心细致，全程照顾老人需求。',
      '服务保障：陪诊员经过专业培训与背景审核，熟悉医院科室分布与就诊流程，具备基本应急常识，遇到异常情况会第一时间联系家属。',
      '温馨提示：预约时请提供就诊医院、科室与时间，以及老人基本健康状况。本页面提交为演示流程，实际预约请通过客服确认。',
    ],
  },
  {
    id: 's7',
    type: 'service',
    title: '一对一学科辅导',
    summary: '资深教师一对一辅导，覆盖语数外等主要科目，因材施教，线上线下均可安排。',
    image:
      'https://readdy.ai/api/search-image?query=Tutor%20teaching%20a%20student%20one%20on%20one%20at%20a%20bright%20desk%20with%20books%20and%20notebooks%2C%20editorial%20education%20service%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light&width=800&height=600&seq=svc-07&orientation=landscape',
    category: 'life',
    subCategory: '教育',
    serviceType: '教育辅导',
    price: '¥160 起 / 课时',
    area: '市区可上门',
    author: '91生活服务',
    source: '认证教师',
    publishTime: '2026-10-02 13:45',
    views: 52900,
    tags: ['一对一辅导', '学科', '提分'],
    content: [
      '每个孩子的学习基础与节奏各不相同，一对一辅导能够更有针对性地解决学习中的难点。本服务由经验丰富的教师授课，覆盖语文、数学、外语等主要科目。',
      '辅导方式：可根据需要选择上门辅导或线上授课。首次沟通会了解学生学习情况与目标，制定个性化辅导计划，并按阶段跟踪学习效果。',
      '服务保障：授课教师均具备相应学科背景与教学经验，试听后如不满意可更换教师。学习过程中会定期与家长沟通反馈，共同帮助学生进步。',
      '温馨提示：本页面提交为演示流程，实际课程安排与费用请通过客服咨询确认。',
    ],
  },
  {
    id: 's8',
    type: 'service',
    title: '私人健身教练上门指导',
    summary: '持证教练上门带练，可根据体能定制训练计划，增肌减脂塑形，居家也能科学锻炼。',
    image:
      'https://readdy.ai/api/search-image?query=Fitness%20coach%20guiding%20a%20person%20workout%20in%20a%20bright%20minimal%20home%20gym%2C%20editorial%20fitness%20service%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light&width=800&height=600&seq=svc-08&orientation=landscape',
    category: 'life',
    subCategory: '健身',
    serviceType: '健身指导',
    price: '¥199 起 / 课时',
    area: '市区可上门',
    author: '91生活服务',
    source: '认证教练',
    publishTime: '2026-10-01 19:00',
    views: 29800,
    tags: ['私教', '上门健身', '减脂'],
    content: [
      '没有时间去健身房，或者不知道怎么科学锻炼？私人健身教练上门指导，让你在家也能高效训练。',
      '服务内容：评估体能与体态 → 制定训练计划 → 上门带练指导 → 动作纠正与饮食建议。无论是增肌、减脂还是塑形，都能获得针对性方案。',
      '服务保障：教练均持有相关专业证书并具备实操经验，训练过程注重安全与循序渐进。可根据家庭空间与器材条件灵活调整训练内容。',
      '温馨提示：运动前请如实告知身体状况。本页面提交为演示流程，实际课程请通过客服预约确认。',
    ],
  },
  {
    id: 's9',
    type: 'service',
    title: '定制旅行路线规划',
    summary: '专业旅行顾问一对一沟通，结合预算与偏好定制行程，涵盖交通、住宿、景点与美食推荐。',
    image:
      'https://readdy.ai/api/search-image?query=Scenic%20travel%20destination%20with%20mountains%20and%20a%20calm%20lake%20at%20golden%20hour%2C%20editorial%20travel%20service%20photography%2C%20clean%20neutral%20background%2C%20warm%20lighting%2C%20high%20detail&width=800&height=600&seq=svc-09&orientation=landscape',
    category: 'life',
    subCategory: '旅行',
    serviceType: '旅行定制',
    price: '¥299 起 / 单',
    area: '线上服务',
    author: '91生活服务',
    source: '认证旅行顾问',
    publishTime: '2026-09-30 10:20',
    views: 33400,
    tags: ['定制旅行', '行程规划', '旅行'],
    content: [
      '自由行虽然灵活，但繁琐的行程规划常常让人头疼。定制旅行服务由专业顾问一对一沟通，根据你的时间、预算与偏好，量身打造专属行程。',
      '服务内容：需求沟通 → 方案设计 → 行程单交付 → 出行前答疑。方案涵盖交通衔接、住宿推荐、景点安排与美食指南，让旅行省心又尽兴。',
      '服务保障：顾问熟悉各地旅游资源与季节特点，能够合理安排行程节奏，避开人潮高峰。行程确定后如需调整，可在出行前免费修改一次。',
      '温馨提示：本页面提交为演示流程，实际定制请通过客服预约顾问沟通。',
    ],
  },
];